import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
 return twMerge(clsx(inputs));
}

export function cleanAlbumDescription(desc: string | null | undefined): string {
 if (!desc) return "";
 
 // 1. Remover o bloco de metadados internos se existir
 const parts = desc.split(/---META---/);
 let clean = parts[0].trim();
 
 // 2. Se a descrição começar com { ou [, é quase certamente um JSON que vazou
 if (clean.startsWith("{") || clean.startsWith("[")) return "";

 // 3. NOVO: Se tiver links do Google Drive ou listagem por barras | ou sequências de download
 // Bloqueamos se houver qualquer indício de dump técnico do Google Drive
 const technicalPatterns = [
 "drive.google.com",
 "export=download",
 "confirm=",
 "https://",
 "http://",
 "storage_mode",
 "drive_only"
 ];

 if (technicalPatterns.some(pattern => clean.includes(pattern))) {
 // Se a string for muito técnica (contém parâmetros de URL ou links repetidos), limpamos
 if (clean.includes("&id=") || clean.includes("?id=") || clean.split("http").length > 2 || clean.length > 100) {
 return "";
 }
 }

 // 4. Detecção de listas técnicas (muitos pipes ou muitas quebras de linha com caracteres especiais)
 if (clean.split("|").length > 3) return ""; 
 
 const lines = clean.split(/\n|\\n/); // Consideramos também o caractere literal \n
 if (lines.length > 3 && lines.some(line => line.includes('=') || line.includes('&') || line.includes('|'))) {
 return "";
 }

 // 5. Se o resultado final for apenas caracteres técnicos residuais ou dump de JSON
 if (/^[\s\n\r{}":,\[\]\\|]+$/.test(clean) || clean.includes('":"')) return "";
 
 return clean;
}
